export default "__VITE_ASSET__B_IPwv70__"